var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Base"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Colour",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 10.0003C1.6665 5.40033 5.39984 1.66699 9.99984 1.66699C14.5998 1.66699 18.3332 5.40033 18.3332 10.0003C18.3332 14.6003 14.5998 18.3337 9.99984 18.3337C5.39984 18.3337 1.6665 14.6003 1.6665 10.0003ZM4.58315 10.0006L8.74982 14.1672L15.4165 7.50055L14.2415 6.31722L8.74982 11.8089L5.75815 8.82555L4.58315 10.0006Z",
    fill: "#32C832"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.930b1b03037fee3b9d6117934a937880.svg";
export { ForwardRef as ReactComponent };